import { queryOptions, useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { OrgTable } from '~/components/features/admin/org-table';
import { PageContainer } from '~/components/layouts/page-container';
import { Button } from '~/components/ui/button';
import { useDocumentTitle } from '~/hooks/use-document-title';
import { api } from '~/lib/api';

const orgsQueryOptions = queryOptions({
  queryKey: ['admin', 'organizations'] as const,
  queryFn: async () => {
    const res = await api.api.admin.organizations.$get();
    if (!res.ok) throw new Error('Failed to fetch organizations');
    return res.json();
  }
});

export const Route = createFileRoute('/_authenticated/admin/organizations/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(orgsQueryOptions),
  component: OrganizationsPage
});

function OrganizationsPage(): React.ReactNode {
  const { t } = useTranslation();
  useDocumentTitle(t('admin.organizations.title'));
  const { data } = useQuery(orgsQueryOptions);
  const organizations = data?.organizations ?? [];
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <PageContainer
      title={t('admin.organizations.title')}
      breadcrumbs={[{ label: t('admin.organizations.title') }]}
      actions={
        <Button
          onClick={() => {
            setCreateOpen(true);
          }}
        >
          <Plus className="size-4" />
          {t('admin.organizations.newOrg')}
        </Button>
      }
    >
      <OrgTable
        organizations={organizations}
        createOpen={createOpen}
        onCreateOpenChange={setCreateOpen}
      />
    </PageContainer>
  );
}
